export default __webpack_public_path__ + "static/media/logo-desktop.ce0c6703.png";